import {
  activeVariantConfig,
  cmp,
  environmentConfig,
  featureToggles,
  logger,
  performanceTrackingService,
  showConsentBannerUseCase,
  broadcaster,
} from '../shared'
import { retryAdapter } from '../shared/adapters'
import { loadOneTrustConsentProviderFactory, onetrustConfig } from './adapters'
import { ConsentProviderPort } from './ports'
import {
  informClientOnConsentChanged,
  isOneTrustEnabled,
  isOneTrustInternalHostingEnabled,
  LoadTimeMeasurement,
} from './core'
import { CONSENT_CHANGED_BROADCAST_EVENT } from '../shared/ports'

export async function bootstrap(): Promise<ConsentProviderPort | undefined> {
  showConsentBannerUseCase.hideInitial()
  const loadTimeMeasurement = new LoadTimeMeasurement(
    performanceTrackingService
  )

  if (!isOneTrustEnabled(featureToggles)) {
    logger.logMessage('OneTrust is not enabled')
    return
  }
  loadTimeMeasurement.startLoadTimeMeasurement()
  const internalHosting: boolean =
    isOneTrustInternalHostingEnabled(featureToggles)
  const loadOnetrustConsentProvider = loadOneTrustConsentProviderFactory(
    logger,
    environmentConfig,
    internalHosting,
    retryAdapter
  )
  const variantConfig = await activeVariantConfig
  const consentProvider = await loadOnetrustConsentProvider(
    onetrustConfig(environmentConfig),
    variantConfig.onetrustVariantId
  )
  loadTimeMeasurement.finishLoadTimeMeasurement()
  cmp.onetrustLoaded.emit({ retain: true })

  /*                                                              */
  consentProvider.OnConsentChanged(async () => {
    await informClientOnOnetrustConsentChange(consentProvider)
  })

  broadcaster.receive(
    CONSENT_CHANGED_BROADCAST_EVENT,
    async () => await cmp.emitConsentChangeEvent()
  )

  return consentProvider
}

async function informClientOnOnetrustConsentChange(
  consentProvider: ConsentProviderPort
) {
  try {
    await informClientOnConsentChanged(consentProvider, cmp, broadcaster)
  } catch (error) {
    logger.logError(
      new Error(`Could not inform client on consent change`, { cause: error })
    )
  }
}
